import { render, staticRenderFns } from "./NavBarPortal.vue?vue&type=template&id=41ba1b0c"
import script from "./NavBarPortal.vue?vue&type=script&lang=js"
export * from "./NavBarPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports